// React & Router
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// Material-UI
import { Grid, Typography, CircularProgress } from '@mui/material';
import { Check } from '@mui/icons-material';

// Styled Components
import styled from 'styled-components';

// Images
import bannerLogin from 'images/banner-login.png';
import bannerMobile from 'images/banner-login-mobile.png';
import Touch from 'images/touch.svg';
import Discount from 'images/discount.svg';
import Headphones from 'images/headphones.svg';
import ItauParceria from 'images/itau-logo-parceria.svg';

// Contexts
import { useAuth } from 'contexts/auth';
import { useTracking } from 'contexts/tracking';

// Components
import EscolherBanco from 'components/EscolherBanco';
import CredorNotFoundDialog from 'dialogs/CredorNotFoundDialog/CredorNotFoundDialog';
import Modal2FA from 'components/Modal/Modal2FA';
import RecaptchaField from 'components/RecaptchaField';

// Services & Utilities
import { encryptData } from 'utils/crypto';
import { buscaCliente, buscaTrackId, IBuscaClienteOut, IBuscaTrackIdIn, IValidaTokenOut, IValidaTrackIdIn, validaTrackId } from 'services/2FA/2FA';
import { disableBodyScroll, enableBodyScroll } from 'utils/scroll-lock';
import { bpDigitalApi } from 'services/api';
import secureLocalStorage from 'react-secure-storage';
import { ToggleElement } from 'utils/toggleElement';

// Interfaces & Constants
import { MENSAGEM_DADOS_INVALIDOS } from 'utils/constants';
import { IUser } from 'interfaces/User';
import { Else, If, Then } from 'react-if';
import { Usa2FA } from 'utils';
import { AcaoEvento } from 'services/TrackingService';
import ModalCarregandoDadosTrackId from 'components/ModalCarregandoDadosTrackId';
import { formatarCnpj, formatarCpf, MaskDocument } from 'utils/maskDocument';
import LoginBradesco from './LoginBradesco/LoginBradesco';
import { useRecaptchaField } from 'contexts/recaptchaField';
import { buscaHonorariosService } from 'services/buscaCredores/buscaCredores';
import ModalHonorario from 'components/Modal/ModalHonorario';
import ModalTentativas from 'components/Modal/ModalTentativas';

const LoginSection = styled(Grid)`
  display: flex;
  position: relative;
  justify-content: flex-end;
  align-items: center;
  background-image: url(${bannerLogin});
  background-size: cover;
  background-position-x: center;
  padding: 15rem 15rem 12rem;
  height: 95vh;

  .loadingContent {
    opacity: 1;
  }

  &.loading {
    padding: 15rem 0 12rem;
    .loginContent {
      opacity: 0;
    }
  }

  @media screen and (max-width: 900px) {
    /* height: unset; */
    padding: 30vh 0 5vh 0;
    align-items: end;
    justify-content: center;
    background-image: url(${bannerMobile});
    background-size: cover;
    background-position-x: center;
    background-position-y: top;
  }

  transition: background-image .3s, padding-right .3s;
`;

const LoginContent = styled.div`
  max-width: 25rem;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  align-items: flex-end;
  transition: opacity .3s;

  @media screen and (max-width: 768px) {
    align-items: center;
  }
`;

const LoginTitle = styled.p`
  color: #fff;
  font-size: 2.5rem;
  font-family: 'Baloo Tamma 2', sans-serif;
  text-align: right;
  line-height: 2.2rem;
  margin: 0;

  @media screen and (max-width: 768px) {
    text-shadow: 0px 0px 30px #000000;
    text-align: center;
  }
`;

const LoginFormBox = styled.form`
  background-color: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  max-width: 22.125rem;
  display: flex;
  flex-direction: column;
  gap: .8rem;
`;

const SectionConsulteSeuCpf = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 8rem 5rem;
  gap: 3rem;
  text-align: center;

  @media (max-width: 768px) {
    padding: 2rem;
    flex-direction: column;
    align-items: center;
  }
`;

const SectionConsulteBox = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const SectionLimpeSeuNome = styled.section`
  background-color: #EAEAEA;
  display: flex;
  flex-direction: column;
  gap: 3rem;

  padding: 5rem 10rem;
  @media (max-width: 768px) {
    padding: 2rem;
    flex-direction: column;
    align-items: center;
  }
`;

const GridLimpeSeuNome = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;

  @media screen and (max-width: 1050px) {
    gap: 2rem;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
`;

const BoxLimpeSeuNome = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 15rem;

  img {
    height: 4.5rem;
    width: 4.5rem;
  }

  @media screen and (max-width: 1050px) {
    max-width: unset;
  }
`;

const BotaoConsultarGratis = styled.button`
  background-color: #A82047;

  &:hover {
    background-color: #FF2F63;
  }


  font-family: 'Poppins';
  font-size: 1rem;
  color: #fff;
  border-radius: 8px;
  height: 2.5rem;
  width: 12rem;
  margin: 0 auto;
  border: none;
  cursor: pointer;

  transition: all .1s;
`;

const StyledForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: .8rem;
`;
const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: .4rem;
`;

const NormalInputContent = styled.div`
  position: relative;

  input {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    height: 3.5rem;
    outline: none;
    border-radius: 4px;
    border: 1px solid #c4c4c4;
    padding: 1.125rem 0.875rem;
    font-family: 'Baloo Tamma 2', sans-serif;
    transition: border .3s;
    font: inherit;
    color: currentColor;
    -webkit-background-clip: text !important;
    background-clip: text !important;
  }

  input:focus {
    border-color: #A82047;
    background-color: white !important;
  }

  input:focus + legend {

  }

  legend {
    padding: 0 .2rem;
    position: absolute;
    pointer-events: none;
    left: .85rem;
    background-color: white;
    transition: all .15s;
    top: -.5rem;
    font-size: .75rem;
    color: #115222;
  }
  legend[aria-hidden="true"] {
    opacity: 0;
  }
`;

const OlaNome = styled.h5`
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 1.375rem;
  margin: 0;
  color: #212121;

  text-transform: capitalize;
`;

const SubTitle = styled.p`
  font-family: 'Poppins';
  font-weight: 400;
  font-size: 1.0625rem;
  margin: 0;
  line-height: 1.25rem;
  color: '#212121';
`;

const PreFilledInputContent = styled.div`
  height: 3.5rem;
  display: flex;
  flex-direction: row;

  input, div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 0 1rem;
  }
`;
const DocumentInput = styled.input`
  width: 100%;
  border-radius: 4px 0 0 4px;
  outline: none;

  border: none;
  border-top: 1px solid rgba(0, 0, 0, .23);
  border-left: 1px solid rgba(0, 0, 0, .23);
  border-bottom: 1px solid rgba(0, 0, 0, .23);

  font: inherit;
  color: currentColor;
  -webkit-background-clip: text !important;
  background-clip: text !important;

  &:focus {
    border-color: #A82047;
  }

  transition: all .3s;
`
const FilledDocumentBox = styled.div`
  color: #252A34;
  background-color: rgba(0, 0, 0, .1);
  border-radius: 0 4px 4px 0;

  border: 1px solid rgba(0, 0, 0, .23);

  white-space: nowrap;
  text-transform: uppercase;
  font-family: 'Poppins', sans-serif;
  font-size: 1.0625rem;
  font-weight: 400;
`

const WarningText = styled.p`
  color: #C00000;
  font-size: .8rem;
  text-align: left;
  align-items: center;
  margin: 0;

  opacity: 0;
  pointer-events: none;

  max-height: 0;
  &.visible {
    max-height: 1.2rem;
    pointer-events: auto;
    opacity: 1;
  }
  transition: all .15s;
`;

const CaptchaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: .4rem;
`;

const BotaoConsultar = styled.button`
  font-size: 1rem;
  font-weight: 500;
  font-family: 'Poppins', sans-serif;
  height: 3.5rem;
  width: 100%;
  display: flex;
  align-items: center;
  line-height: 1.625rem;
  justify-content: center;
  color: #fff;
  background-color: #A82047;
  border-radius: 8px;
  outline: none;
  border: none;
  cursor: pointer;
  &:hover {
    background-color: #FF2E63;
  }
  &:disabled {
    cursor: not-allowed;

    background-color: #a8a8a8;
    &:hover {
      background-color: #a8a8a8;
    }
  }

  transition: background-color .3s;

  &.submitting {
    pointer-events: none;
  }
`;

const FinanceiraItauBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: .8rem;
  width: 100%;
  align-items: center;

  text-align: center;
  font-size: .8rem;

  p {
    margin: 0;
    font-weight: 500;
  }
`;

function valorCnpjAlfa(ch: string): number {
    if (/[0-9]/.test(ch)) return parseInt(ch);
    if (/[A-Z]/.test(ch)) return ch.charCodeAt(0) - 48;
    if (/[a-z]/.test(ch)) return ch.toUpperCase().charCodeAt(0) - 48;
    return 0;
  }

function calculaDV(parte: string): number {
  let soma = 0;
  let pesoIndex = 0;
  const valores = parte.split("").map(valorCnpjAlfa);
  const pesos = [2, 3, 4, 5, 6, 7, 8, 9];

  for (let i = valores.length - 1; i >= 0; i--) {
     soma += valores[i] * pesos[pesoIndex];
     pesoIndex = (pesoIndex + 1) % pesos.length;
  }

  const resto = soma % 11;
  return resto === 0 || resto === 1 ? 0 : 11 - resto;
}

function ValidarCpfCnpj(doc: string | null): boolean {
  if (doc === null) {
    return false;
  }

  doc = doc.replace(/[^a-zA-Z0-9]+/g, '');

  if (doc.length === 11) {
    if (/^(\d)\1{10}$/.test(doc)) {
      return false;
    }

    let soma = 0;
    for (let i = 0; i < 9; i++) {
      soma += parseInt(doc[i]) * (10 - i);
    }

    let resto = soma % 11;
    let digito1 = resto < 2 ? 0 : 11 - resto;

    soma = 0;
    for (let i = 0; i < 10; i++) {
      soma += parseInt(doc[i]) * (11 - i);
    }

    resto = soma % 11;
    let digito2 = resto < 2 ? 0 : 11 - resto;

    if (digito1 === parseInt(doc[9]) && digito2 === parseInt(doc[10])) {
      secureLocalStorage.setItem('doc', doc)
      return true;
    }
  }

  if (doc.length === 14) {
    if (/([^a-zA-Z0-9])\1{13}$/.test(doc)) {
      return false;
    }

    const base = doc.substring(0, 12);
    const digitos = doc.substring(12);

    const dv1 = calculaDV(base);
    const dv2 = calculaDV(base + dv1.toString());

    if (parseInt(digitos[0]) !== dv1 || parseInt(digitos[1]) !== dv2) {
      return false;
    }

    secureLocalStorage.setItem('doc', doc)
    return true;
  }

  secureLocalStorage.removeItem('doc')
  return false;
}

function ToggleButton(elementId: string, toggle: boolean) {
  const element = document.getElementById(elementId) as HTMLButtonElement

  if (toggle) {
    element.disabled = !toggle
    element.classList.remove("disabled")
  }
  else {
    element.disabled = !toggle
    element.classList.add("disabled")
  }
}

export function ValidarFormulario(doc = "") {
  const appNeedCaptcha: boolean = !!!process.env.REACT_APP_PASS
  const captchaIsInvalid: boolean = !!!(secureLocalStorage.getItem("@grecaptcha"))
  let documentIsInvalid = false
  const docInput = document.getElementById("documento-input") as HTMLInputElement

  if (!!doc) {
    doc = doc.replace(/[^a-zA-Z0-9]/g, "");
  } 
  else {
    doc = docInput.value.replace(/[^a-zA-Z0-9]/g, "");
  }

  if (docInput.maxLength === 5) {
    documentIsInvalid = doc.length != 4
  }
  else {
    documentIsInvalid = !ValidarCpfCnpj(doc);
  }

  ToggleElement("wt-cpf", false)
  ToggleElement("wt-grecaptcha", false)

  if (documentIsInvalid) {
    ToggleElement("wt-cpf", true)
  }
  if (appNeedCaptcha && captchaIsInvalid) {
    ToggleElement("wt-grecaptcha", true)
  }


  if (documentIsInvalid || (appNeedCaptcha && captchaIsInvalid)) {
    ToggleButton('botao-consultar', false)
    return false
  }

  ToggleButton('botao-consultar', true)
  return true
}


export enum SituacaoCredor {
  CredorNaoEncontrado = 'CredorNaoEncontrado',
  DadosNaoEncontrado = 'DadosNaoEncontrado',
  Indefinido = 'Indefinido'
}

export const getCpfCnpjSemFormatacao = (): string => {
  const inputCpfCnpj = document.getElementById("documento-input") as HTMLInputElement
  return inputCpfCnpj.value.replace(/[^a-zA-Z0-9]+/g, '')
}

export default function Login() {
  const navigate = useNavigate();
  const { signIn, setBank, signOut } = useAuth();
  const [preventLogin, setPreventLogin] = useState(false);
  const [errorLoginMessage, setErrorLoginMessage] = useState('');
  const [openCredorNotFound, setOpenCredorNotFound] = useState<SituacaoCredor>(SituacaoCredor.Indefinido);
  const [cliente, setCliente] = useState<IBuscaClienteOut>()
  const { trackId } = useParams<{ trackId: string | undefined }>()
  const { sendTracking } = useTracking();
  const [submitting, setSubmitting] = useState(false)
  const [inputCpf, setInputCpf] = useState("")
  const [inputLegend, setInputLegend] = useState("Digite seu documento (CPF/CNPJ)")
  const [documentoIncompletoCliente, setDocumentoIncompletoCliente] = useState("")
  const [docType, setDocType] = useState("")
  const isInvalidTrackId = (trackId?.length != 10 && trackId?.length != 13)
  const FINANCEIRA = process.env.REACT_APP_FINANCEIRA || '';
  const {captchaRef} = useRecaptchaField()

  const [isModalHonorarioOpen, setModalHonorarioOpen] = useState(false);
  const [openTentativas, setOpenTentativas] = useState(false);

  useEffect(
    () => {
      signOut()

      if (trackId) {
        if (isInvalidTrackId) {
          navigate('/login')
        }

        ToggleElement("modal-loading-trackid", true)
        disableBodyScroll(document.body)

        const _buscaTrackIdIn: IBuscaTrackIdIn = {
          AppId: process.env.REACT_APP_ID as string,
          TrackId: trackId as string
        }

        const _buscaTrackId = async () => {
          await buscaTrackId(_buscaTrackIdIn)
            .then(
              () => {
                const docCliente = localStorage.getItem("@documentoIncompletoCliente") as string
                setDocType(docCliente.length === 7 ? "cpf" : "cnpj")
                setDocumentoIncompletoCliente(docCliente.length === 7 ? formatarCpf("0000" + docCliente) : formatarCnpj("0000" + docCliente))
              }
            )
            .catch(
              () => {
                navigate('/login')
              }
            )
            .finally(
              () => {
                const loginSection = document.getElementById("login-section")
                loginSection?.classList.remove("loading")
                ToggleElement("modal-loading-trackid", false)
                enableBodyScroll(document.body)
              }
            )
        }

        _buscaTrackId()
      }
      else {
        const loginSection = document.getElementById("login-section")
        loginSection?.classList.remove("loading")
      }

      sendTracking({ trackId, acao: AcaoEvento.Home })
    }, []
  );

  const fecharModal2FA = () => {
    let Modal2FA = document.getElementById("overlay-modal-2fa") as HTMLDialogElement
    enableBodyScroll(document.body)
    Modal2FA.classList.remove("open")
  }

  async function verificarHonorarios() {
  try {
    const { data } = await buscaHonorariosService({
      headers: {
        Authorization: `Bearer ${secureLocalStorage.getItem("@token")}`,
      },
    });

    if (data) {
      setModalHonorarioOpen(true);
      setOpenCredorNotFound(SituacaoCredor.Indefinido)
    }
  } catch (err) {
    console.error("Erro ao buscar honorários:", err);
  }
};

  async function buscarCredores(cpfCnpj: string | undefined) {
    setErrorLoginMessage('');
    const user: IUser | undefined = await signIn();

    if (user?.mensagemRetorno?.sucesso && !user?.credores?.length) {
      navigate('/sucesso');
      return;
    }

    if (!user?.mensagemRetorno?.sucesso) {
      if (user?.mensagemRetorno?.msgRetorno === MENSAGEM_DADOS_INVALIDOS && user.nome == undefined) {
        sendTracking({ trackId, acao: AcaoEvento.DadosInvalidos, cpfCnpj: cpfCnpj });
        setErrorLoginMessage(MENSAGEM_DADOS_INVALIDOS);
      } else {
        fecharModal2FA()
        captchaRef?.reset()
        setOpenCredorNotFound(SituacaoCredor.CredorNaoEncontrado);
      }
    }

    if (user?.mensagemRetorno?.sucesso && Number(user?.credores?.length) > 1) {
      setPreventLogin(true);
      return;
    }

    if (!!user?.credores?.length) {
      const [bank] = user.credores;

      setBank(bank);
      localStorage.setItem('@bank', encryptData(bank));
      navigate('/dashboard');
    }

    if(user?.cnpJ_CPF == null || user.cnpJ_CPF == undefined){
      await verificarHonorarios();
    }
  }

  const RealizarLogin = async () => {
    const inputCpfCnpj = document.getElementById("documento-input") as HTMLInputElement
    const cpfCnpj = inputCpfCnpj.value.replace(/[^a-zA-Z0-9]+/g, '') + documentoIncompletoCliente?.slice(4).replace(/[^a-zA-Z0-9]+/g, '')

    !Usa2FA && sendTracking({ trackId, acao: AcaoEvento.ConsultarCPF, cpfCnpj });

    if (trackId) {
      const _validaTrackIdIn: IValidaTrackIdIn = {
        appId: process.env.REACT_APP_ID,
        cpfCnpj: cpfCnpj,
        trackId: trackId
      }
      await validaTrackId(_validaTrackIdIn)
        .then(
          async () => {
            await buscarCredores(cpfCnpj)
          }
        )
        .catch(
          () => {
          captchaRef?.reset()
            setOpenCredorNotFound(SituacaoCredor.CredorNaoEncontrado)
          }
        )
    }
    else {
      setSubmitting(true)
      await buscarCredores(cpfCnpj)
        .finally(() => setSubmitting(false))
    }
  };

  const Autenticar2FA = async () => {
    const cpfCnpj = getCpfCnpjSemFormatacao() + documentoIncompletoCliente?.slice(5).replace(/[^a-zA-Z0-9]+/g, '');
    sendTracking({ trackId, acao: AcaoEvento.ConsultarCPF, cpfCnpj });

  try {
    const response = await buscaCliente(cpfCnpj, setCliente);

    if (response.loginType === "CpfCnpj") {
      secureLocalStorage.setItem("@token", response?.token ?? "");
      setSubmitting(true);
      await buscarCredores(cpfCnpj)
        .finally(() => setSubmitting(false));
      return;
    }

    const modal2FA = document.getElementById("overlay-modal-2fa") as HTMLDialogElement;
    modal2FA.classList.add("open");
    disableBodyScroll(document.body);
  } catch (error: any) {

    if (error.response?.status === 429) {
      setOpenTentativas(true);
      return;
    }
    
    captchaRef?.reset();
    setOpenCredorNotFound(SituacaoCredor.CredorNaoEncontrado);
  }
};

  const onChooseBanco: any = (value: any) => {
    setBank(value);
    localStorage.setItem('@bank', encryptData(value));
    navigate('/dashboard');    
  };

  const onFocusDocumentoInput = () => {
    const input = document.getElementById('documento-input');

    window.scrollTo(0, 0);
    input?.focus();
  };

  if (FINANCEIRA === 'bradesco') {
    return (
      <>
        <LoginBradesco
          onSubmit={trackId ? RealizarLogin : Autenticar2FA}
          docType={docType}
          documentoIncompletoCliente={documentoIncompletoCliente}
        />

        <CredorNotFoundDialog
          situacao={openCredorNotFound}
          open={openCredorNotFound != SituacaoCredor.Indefinido}
          onClose={() => setOpenCredorNotFound(SituacaoCredor.Indefinido)}
          financeira={FINANCEIRA}
          buscarCpfCnpjSemFormatacao={getCpfCnpjSemFormatacao}
        />

        <Modal2FA
          isOpen={true}
          cliente={cliente}
          setOpenCredorNotFound={setOpenCredorNotFound}
          setSubmitting={setSubmitting}
          realizarLogin={RealizarLogin}
        />
      </>
    )
  }

  return (
    <>
      <LoginSection id='login-section' className='loading'>
        <LoginContent className='loginContent'>

          <LoginTitle>
            Negocie suas dívidas e mude o rumo da sua vida agora mesmo!
          </LoginTitle>

          <LoginFormBox>
            <If condition={preventLogin}>

              <Then>
                <EscolherBanco
                  onReset={() => setPreventLogin(false)}
                  onChooseBanco={onChooseBanco}
                />
              </Then>

              <Else>
                {
                  trackId &&
                  (
                    <OlaNome>
                      {
                        localStorage.getItem("@nomeCliente") ?
                          (
                            `Olá, ${localStorage.getItem("@nomeCliente")?.toLowerCase()}`
                          )
                          :
                          (
                            "Olá!"
                          )
                      }
                    </OlaNome>
                  )
                }

                <SubTitle>
                  {
                    trackId ?
                      (
                        "Para sua segurança, digite os 4 primeiros dígitos do seu CPF ou CNPJ"
                      )
                      :
                      (
                        "Consulte na Bellinati se existem dívidas no seu CPF ou acompanhe seus acordos"
                      )
                  }
                </SubTitle>

                <StyledForm>
                  <InputContainer>
                    <WarningText id="wt-cpf">Documento obrigatório. *</WarningText>

                    {
                      trackId ?
                        (
                          <PreFilledInputContent>
                            <DocumentInput
                              id="documento-input"
                              type="text"
                              onChange={
                                (e) => {
                                  const documentoDigitado = e.target.value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 4);

                                  if (docType === "cpf") {
                                    const documentoFormatado = formatarCpf(documentoDigitado)
                                    setInputCpf(documentoFormatado)
                                  }
                                  if (docType === "cnpj") {
                                    const documentoFormatado = formatarCnpj(documentoDigitado)
                                    setInputCpf(documentoFormatado)
                                  }
                                }
                              }
                              onKeyUp={
                                (e) => {
                                  const inputDocumento = document.getElementById("documento-input") as HTMLInputElement
                                  const documentoDigitado = inputDocumento.value

                                  if (documentoDigitado.length > 0) {
                                    ValidarFormulario(documentoDigitado)
                                  }
                                }
                              }
                              inputMode="numeric"
                              value={inputCpf}
                              maxLength={5}
                              required
                            />
                            <FilledDocumentBox>{documentoIncompletoCliente.slice(5)}</FilledDocumentBox>
                          </PreFilledInputContent>
                        )
                        :
                        (
                          <NormalInputContent>
                            <input
                              id="documento-input"
                              type="text"
                              onChange={
                                (e) => {
                                  ValidarFormulario(e.target.value)
                                  setInputCpf(MaskDocument(e.target.value))
                                }
                              }
                              inputMode="text"
                              value={inputCpf}
                              maxLength={18}
                              required
                            />
                            <legend>{inputLegend}</legend>
                          </NormalInputContent>
                        )
                    }

                  </InputContainer>

                  {
                    !process.env.REACT_APP_PASS &&
                    (
                      <CaptchaContainer>
                        <WarningText id="wt-grecaptcha">Captcha obrigatório. *</WarningText>
                        <RecaptchaField />
                      </CaptchaContainer>
                    )
                  }

                  <BotaoConsultar
                    id="botao-consultar"
                    type="button"
                    onClick={
                      async () => {
                        const formIsValid = ValidarFormulario(inputCpf)

                        if (formIsValid) {
                          ToggleElement("wt-cpf", false)
                          setSubmitting(true);

                          if (!trackId) {
                            await Autenticar2FA()
                          }
                          else {
                            await RealizarLogin()
                              .catch(
                                () => {
                                  setOpenCredorNotFound(SituacaoCredor.DadosNaoEncontrado);
                                  setSubmitting(false)
                                }
                              )
                          }

                          setSubmitting(false)
                        }
                      }
                    }
                    className={submitting ? "submitting" : ""}
                  >
                    {
                      submitting ?
                        (
                          <CircularProgress style={{ color: '#fff' }} size={23} />
                        )
                        :
                        (
                          "Consultar"
                        )
                    }
                  </BotaoConsultar>
                  <ModalHonorario
                    open={isModalHonorarioOpen}
                    onClose={() => setModalHonorarioOpen(false)}
                  />
                  <ModalTentativas
                      open={openTentativas}
                      onClose={() => setOpenTentativas(false)}
                    />
                  {
                    FINANCEIRA === 'itau' &&
                    (
                      <FinanceiraItauBox>
                        <img
                          style={{ height: 50, width: 280, objectFit: 'cover' }}
                          src={ItauParceria}
                          alt="Parceria Itaú"
                        />
                        <p>Consulte a nossa parceria com o banco através do link:</p>
                        <a href="https://www.itau.com.br/renegociacao" target="_blank">https://www.itau.com.br/renegociacao</a>
                      </FinanceiraItauBox>
                    )
                  }
                </StyledForm>
              </Else>

            </If>
          </LoginFormBox>

        </LoginContent >
      </LoginSection >

      {
        !trackId &&
        (
          <>
            <SectionConsulteSeuCpf>

              <SectionConsulteBox >
                <Typography variant="h4" style={{ fontWeight: 600, fontSize: 32, fontFamily: "Baloo Tamma 2" }}>
                  Consulte seu CPF, e assuma o controle do seu financeiro
                </Typography>
              </SectionConsulteBox>

              <SectionConsulteBox >

                <Typography
                  variant="h6"
                  style={{ fontWeight: 'normal', fontFamily: "Baloo Tamma 2" }}
                >
                  <Check style={{ color: '#5AD87C' }} />
                  Negociações facilitadas
                </Typography>

                <Typography variant="h6" style={{ fontWeight: 'normal', fontFamily: "Baloo Tamma 2" }}>
                  <Check style={{ color: '#5AD87C' }} />
                  Parcelamento e desconto
                </Typography>

              </SectionConsulteBox>

            </SectionConsulteSeuCpf>

            <SectionLimpeSeuNome>

              <Typography
                variant="h3"
                style={{ fontFamily: "Baloo Tamma 2", lineHeight: '30px', fontWeight: 600, textAlign: 'center', fontSize: '32px' }}
              >
                Limpe seu nome agora mesmo!
              </Typography>

              <GridLimpeSeuNome>
                <BoxLimpeSeuNome>
                  <img src={Touch} alt="touch" />
                  <Typography
                    variant="h6"
                    style={{ fontWeight: 600, textAlign: 'center' }}
                  >
                    Negocie automaticamente
                  </Typography>
                  <Typography
                    variant="h6"
                    style={{
                      fontWeight: 'normal',
                      fontSize: 16,
                      textAlign: 'center',
                      color: '#707070',
                    }}
                  >
                    Um portal de negociação totalmente automático.
                  </Typography>
                </BoxLimpeSeuNome>

                <BoxLimpeSeuNome>
                  <img src={Discount} alt="selo de desconto" />
                  <Typography
                    variant="h6"
                    style={{ fontWeight: 600, textAlign: 'center' }}
                  >
                    Descontos e facilitação dos pagamentos
                  </Typography>
                  <Typography
                    variant="h6"
                    style={{
                      fontWeight: 'normal',
                      fontSize: 16,
                      textAlign: 'center',
                      color: '#707070',
                    }}
                  >
                    Tenha acesso a descontos e parcelamento das dívidas.
                  </Typography>
                </BoxLimpeSeuNome>

                <BoxLimpeSeuNome>
                  <img src={Headphones} alt="suporte" />
                  <Typography
                    variant="h6"
                    style={{ fontWeight: 600, textAlign: 'center' }}
                  >
                    Suporte rápido e personalizado
                  </Typography>
                  <Typography
                    variant="h6"
                    style={{
                      fontWeight: 'normal',
                      fontSize: 16,
                      textAlign: 'center',
                      color: '#707070',
                    }}
                  >
                    Se tiver dúvidas, nossa equipe entra em contato para ajudar!
                  </Typography>
                </BoxLimpeSeuNome>
              </GridLimpeSeuNome>

              <BotaoConsultarGratis onClick={onFocusDocumentoInput}>
                Consultar Grátis
              </BotaoConsultarGratis>

            </SectionLimpeSeuNome>
          </>
        )
      }

      <CredorNotFoundDialog
        situacao={openCredorNotFound}
        open={openCredorNotFound != SituacaoCredor.Indefinido}
        onClose={() => setOpenCredorNotFound(SituacaoCredor.Indefinido)}
        financeira={FINANCEIRA}
        buscarCpfCnpjSemFormatacao={getCpfCnpjSemFormatacao}
      />

      <Modal2FA
        isOpen={true}
        cliente={cliente}
        setOpenCredorNotFound={setOpenCredorNotFound}
        setSubmitting={setSubmitting}
        realizarLogin={
          () => {
            RealizarLogin()
          }
        }
      />

      <ModalCarregandoDadosTrackId />
    </>
  );
}
